import moment from 'moment';

const handleOnCheckTime = (activeTime) => {
  const { beginDate, beginTime, endDate, endTime } = activeTime || {};
  if (beginDate && beginTime && !endDate && !endTime) {
    return { valid: true };
  }
  if (beginDate && beginTime && endDate && endTime) {
    const end = `${endDate} ${endTime}`;
    const isAfter = moment(end).isAfter(new Date());
    return { valid: isAfter, message: 'Unable to publish an expired discount' };
  }
  return { valid: false };
};
export { handleOnCheckTime };
